export default function parseResTypes(resTypes) {
  //convert array to values react select can read
  let returnValue = [];
  for (var i = 0; i < resTypes.length; i++) {
    returnValue.push({
      value: resTypes[i].id,
      label: `${resTypes[i].name} (${resTypes[i].id})`,
    });
  }
  return returnValue;
}
